import React from "react";
import PackageCard from "../../components/PackageCard/PackageCard";

export default function StarPackages({ prices, packages, pending, loadingPkg, pkgCount, labels, onActivate, onRetopup, onClaimDiv }) {
  return (
    <div className="plan-packages-grid">
      {Array.from({ length: pkgCount }, (_, i) => {
        const isActive = packages ? packages.a[i] : false;
        const prevActive = i === 0 ? true : (packages ? packages.a[i - 1] : false);
        const canActivate = !isActive && prevActive;

        return (
          <PackageCard
            key={i}
            index={i}
            label={labels[i]}
            price={prices[i]}
            isActive={isActive}
            canActivate={canActivate}
            ceiling={packages ? packages.c[i] : undefined}
            earned={packages ? packages.e[i] : undefined}
            remaining={packages ? packages.r[i] : undefined}
            pending={pending[i]}
            holdBal={packages && packages.h ? packages.h[i] : undefined}
            onActivate={onActivate}
            onRetopup={onRetopup}
                        loading={loadingPkg === i}
          />
        );
      })}
    </div>
  );
}
